import type { ReactElement } from 'react';

import BotonesFooter from './botonesFooter';
import Emisor from './emisor';
import DatosDeLaEmpresa from './Interno/datosDeLaEmpresa';
import DetalleAlta from '../components/detalleAlta';
import ServiciosYNotificaciones from '../components/serviciosYNotificaciones';

const EmpresaEdit = (): ReactElement => (
	<div className='c-pnp-company' >
		<div className='c-pnp-company__container'> 
			<Emisor />
			<div className='c-pnp-company__container-internal'>
				<DatosDeLaEmpresa />
				<DetalleAlta />
				<ServiciosYNotificaciones />
			</div>
			<BotonesFooter />
		</div>
	</div>
);

export default EmpresaEdit;
